import React from 'react';
import { IOS_SUBSCRIPTION_MANAGE_KEY } from '../utils/iosCommerceGate';
import { useTranslation } from '../i18n/useTranslation';

const DEFAULT_STYLE = {
  fontSize: 14, lineHeight: 1.6,
  color: 'var(--text-secondary, rgba(255,255,255,0.55))', margin: 0,
};

/**
 * App Store 3.1.1 — no in-app subscribe/checkout/portal surfaces on iOS (#408).
 */
export default function IosSubscriptionManageHint({ style, className, centered = false }) {
  const { t } = useTranslation();
  return (
    <p
      className={className}
      data-testid="ios-subscription-manage-hint"
      style={{
        ...DEFAULT_STYLE,
        ...(centered ? { textAlign: 'center' } : null),
        ...style,
      }}
    >
      {t(IOS_SUBSCRIPTION_MANAGE_KEY)}
    </p>
  );
}
